<template src="./validate-account.html"></template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'
import { mask } from 'vue-the-mask'
import ContextPage from '@/components/context-page/ContextPage'
import Moment from 'moment'
import { EventBus } from '@/router/bus'

Vue.use(Vuelidate)

const AUTHORIZATION = 'Authorization'

export default {
  name: 'register-account',
  components: { ContextPage },
  mixins: [validationMixin],
  directives: { mask },
  filters: {
    kb (val) {
      return Math.floor(val / 1024)
    }
  },
  data () {
    return {
      loading: false,
      documentUploading: false,
      uploadSuccess: false,
      menu: false,
      user: null,
      confirmationDialog: false,
      activationId: '',
      identificationNumberMask: '#########',
      uniqueIdentificationNumberMask: '#############',
      fileError: false,
      fileErrorMessage: null,
      dropzoneOptions: {
        acceptedFiles: ['.pdf'],
        defaulttext: 'Превуците датотеку'
      },
      dragging: false,
      file: false,
      acceptedFormat: ['PDF (2MB)'],
      registerAccount: {
        identificationNumber: '',
        uniqueIdentificationNumber: ''
      },
      validationStartDate: Vue.$config.service_config[Vue.$config.service_name].validationStartDate,
      showInstanceLink: Vue.$config.service_config[Vue.$config.service_name].showInstanceLink,
      instanceLink: Vue.$config.service_config[Vue.$config.service_name].instanceLink,
      headline: Vue.$config.service_config[Vue.$config.service_name].headline,
      subHeadline: Vue.$config.service_config[Vue.$config.service_name].subHeadline,
      nameMask: {
        mask: 'CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC',
        tokens: {
          C: {
            pattern: /[a-zA-ZабвгдђежзијклљмнњопрстћуфхцчџшАБВГДЂЕЖЗИЈКЛЉМНЊОПРСТЋУФХЦЧЏШčćšđžČĆŠĐŽ\-\s]/
          }
        }
      },
      UserStatus: {
        PENDING: 1,
        ACTIVE: 2,
        WAITING_ACCOUNT: 3,
        PROCESSED: 4,
        COMPLETED: 5,
        REJECTED: 6,
        ERROR: 7,
        BLOCKED: 8,
        TEMP_BLOCKED: 8,
        REQUIRES_CONFIRMATION: 101,
        CONFIRMATION_PROVIDED: 102
      },
      status: [
        {
          color: '#fff',
          dark: false,
          text: this.$t('subsidyUser.subsidyPending')
        },
        {
          color: '#429a86',
          dark: true,
          text: this.$t('subsidyUser.subsidyActive')
        },
        {
          color: '#429a86',
          dark: true,
          text: this.$t('subsidyUser.waitingAccount')
        },
        {
          color: '#429a86',
          dark: true,
          text: this.$t('subsidyUser.subsidyProcessed')
        },
        {
          color: '#3d92b6',
          dark: true,
          text: this.$t('subsidyUser.subsidyCompleted')
        },
        {
          color: '#ffac81',
          dark: false,
          text: this.$t('subsidyUser.subsidyRejected')
        },
        {
          color: '#d3454a',
          dark: true,
          text: this.$t('subsidyUser.subsidyError')
        },
        {
          color: '#ffac81',
          dark: false,
          text: this.$t('subsidyUser.subsidyRejected')
        },
        {
          color: '#ffac81',
          dark: false,
          text: this.$t('subsidyUser.subsidyRejected')
        }
      ]
    }
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  computed: {
    validationEnabled () {
      return Moment() > Moment(this.validationStartDate)
    },
    uniqueIdentificationNumberErrors () {
      return this.getValidationErrorsByName('uniqueIdentificationNumber')
    },
    identificationNumberErrors () {
      return this.getValidationErrorsByName('identificationNumber')
    },
    userStatusMessage () {
      return this.formatUserStatus(this.user, this.UserStatus)
    },
    userValidationFailed () {
      if (!this.user) { return false }
      return this.user.status === this.UserStatus.PENDING && this.user.processed === true
    },
    requiresDocumentConfirmation () {
      if (!this.user) { return false }
      return this.user.status === this.UserStatus.REQUIRES_CONFIRMATION
    },
    documentConfirmationProvided () {
      if (!this.user) { return false }
      return this.user.status === this.UserStatus.CONFIRMATION_PROVIDED
    }
  },
  methods: {
    home () {
      this.$router.push({ name: 'StartPage' })
    },
    gotoInstance () {
      window.open(this.instanceLink + 'provera', '_blank')
    },
    validateBeforeSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(function () {
          document.body.scrollTop = 0
        })
        return
      }
      this.validateAccount()
    },
    stepValid () {
      if (this.user && this.user.status === this.UserStatus.PROCESSED) {
        if (this.user.paymentMessage) { return false }
      }

      return true
    },
    stepValue () {
      if (this.user && this.user.status === this.UserStatus.ACTIVE) {
        if (this.user.accountChangeDate !== null) { return 3 }

        return 1
      }

      if (this.user && this.user.status === this.UserStatus.WAITING_ACCOUNT) {
        return 2
      }

      return this.user.status
    },
    validateAccount () {
      this.loading = true
      this.$http.post(Vue.$apiConfig.validateAnonymousUserPost, this.registerAccount).then(
        response => {
          this.loading = false
          this.logConsole(response)
          this.clearRegisterModelData()
          this.user = response.data.payload
          this.confirmationDialog = true
        },
        error => {
          this.loading = false
          this.formatErrorResponse(error)
        })
    },
    getValidationErrorsByName (name) {
      if (!this.$v.registerAccount[name].$dirty) return []
      return this.getValidationErrors('registerAccount').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    closeConfirmationDialog () {
      this.confirmationDialog = false
      this.$router.push('/')
    },
    clearRegisterModelData () {
      this.registerAccount.identificationNumber = ''
      this.registerAccount.uniqueIdentificationNumber = ''
      this.$v.$reset()
    },
    addFile (e) {
      this.fileError = false
      EventBus.$emit('page-loader', true)
      const droppedFiles = e.target.files || e.dataTransfer.files
      if (!droppedFiles) {
        return
      }
      if (droppedFiles.length > 1) {
        this.fileError = true
        this.fileErrorMessage = this.$t('dropzone.tooManyFiles')
        return
      }
      if (!this.dropzoneOptions.acceptedFiles.includes('.' + droppedFiles[0].name.split('.').pop().toLowerCase())) {
        EventBus.$emit('page-loader', false)
        this.fileError = true
        this.fileErrorMessage = this.$t('dropzone.unsupportedFile')
        return
      }
      this.file = droppedFiles[0]
      this.$refs.fileUpload.value = ''
      const reader = new FileReader()
      reader.onload = (e) => {
        this.loadedFile = e.target.result
        this.dropzoneSuccess()
      }
      reader.readAsText(this.file)
    },
    removeFile () {
      this.file = false
    },
    dropzoneSuccess () {
      if (this.file.name.length > 100) {
        this.file = null
        this.fileError = true
        this.fileErrorMessage = this.$t('errors.fileNameLength')
      }
      if (this.file.size > 3145728) {
        this.file = null
        this.fileError = true
        this.fileErrorMessage = this.$t('errors.fileSize')
      }
    },
    uploadDocument () {
      this.documentUploading = true
      this.fileError = false
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('documentIdentifier', this.user.uniqueIdentificationNumber)

      Vue.http.headers.common[AUTHORIZATION] = 'Bearer ' + this.user.dmsToken

      this.$http.post(`${Vue.$config.dms_root}/${Vue.$apiConfig.uploadDocumentPost}`, formData).then(
        response => {
          this.file = null
          this.documentUploading = false
          this.logConsole(response)
          Vue.http.headers.common[AUTHORIZATION] = null
          this.uploadSuccess = true
        },
        error => {
          this.documentUploading = false
          this.fileError = true
          Vue.http.headers.common[AUTHORIZATION] = null
          this.fileErrorMessage = this.getErrorResponse(error)
        })
    }
  },
  validations () {
    const rules = {}

    Object.assign(rules, {
      uniqueIdentificationNumber: {
        required,
        minLength: minLength(13),
        maxLength: maxLength(13)
      },
      identificationNumber: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9)
      }
    })

    return {
      registerAccount: rules
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 20px;
  margin-bottom: 20px;
}

.blue-text {
  color: #1c558a;
}

#file-input {
  display: none;
}
.file-label {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 75px;
}
.file-label p.text {
  margin: auto;
  font-size: 13px !important;
}
.file-label p.icon {
  margin: 0px auto 10px;
}

</style>
